module.exports = __webpack_public_path__ + "img/maintenance-banner.0bae7060.jpg";